import React from 'react';

const Loader = ({ isLoading }) => {
  if (!isLoading) return null;
  
  return (
    <div className="page-loader">
      <div className="loader-content">
        <div className="logo-spinner">
          <img src="/assets/img/logo.svg" alt="Loading..." />
        </div>
        <div className="loading-text font">Caricamento...</div>
      </div>
    </div>
  );
};

export default Loader;